import * as React from 'react';
import { ContainerWrapperProps } from '../ContainerWrapper.types';

const ContainerWrapper: React.FC<ContainerWrapperProps> = ({
  id,
  children,
  tagName,
}) => {
  const SemanticElement = tagName as keyof JSX.IntrinsicElements;
  return <SemanticElement id={id}>{children()}</SemanticElement>;
};

export default ContainerWrapper;
